{
  "name": "billing-portal-ui",
  "version": "1.0.0",
  "private": true,
  "scripts": {
    "ng": "cross-env NODE_OPTIONS=--max_old_space_size=4096 ng",
    "build": "ng build",
    "build-dev": "ng build --configuration=dev",
    "build-int": "ng build --configuration=int",
    "build-stage": "ng build --configuration=stage",
    "build-live": "ng build --configuration=production",
    "build-prod": "ng build --configuration=production",
    "start": "ng serve --proxy-config=proxy.conf.js --port=5000",
    "start-int": "npm start --configuration=int",
    "start-stage": "npm start --configuration=stage",
    "start-prod": "npm start --configuration=production",
    "serve:sw": "build -s && npx http-server ./dist -p 5000",
    "lint": "ng lint && stylelint \"src/**/*.scss\" --syntax scss && htmlhint \"src\" --config .htmlhintrc",
    "test": "ng test",
    "test:ci": "lint -s && ng test --configuration=ci",
    "translations:extract": "ngx-translate-extract --input ./src --output ./src/translations/template.json --format=json --clean --sort --marker extract",
    "prettier": "prettier --write \"./{src,e2e}/**/*.{ts,js,html,scss}\"",
    "prettier:check": "prettier --list-different \"./{src,e2e}/**/*.{ts,js,html,scss}\"",
    "generate": "ng generate"
  },
  "dependencies": {
    "@angular/animations": "20.3.18",
    "@angular/cdk": "20.2.14",
    "@angular/common": "20.3.18",
    "@angular/compiler": "20.3.18",
    "@angular/core": "20.3.18",
    "@angular/flex-layout": "^15.0.0-beta.42",
    "@angular/forms": "20.3.18",
    "@angular/localize": "20.3.18",
    "@angular/platform-browser": "20.3.18",
    "@angular/platform-browser-dynamic": "20.3.18",
    "@angular/router": "20.3.18",
    "@archinsurance-da/arch-portal-tools": "^20.2.0",
    "@auth0/angular-jwt": "^5.2.0",
    "@fortawesome/angular-fontawesome": "^3.0.0",
    "@fortawesome/fontawesome-free": "^6.4.2",
    "@fortawesome/fontawesome-svg-core": "^6.4.2",
    "@fortawesome/free-brands-svg-icons": "^6.4.2",
    "@fortawesome/free-solid-svg-icons": "^6.4.2",
    "@ng-bootstrap/ng-bootstrap": "^19.0.0",
    "@ngbracket/ngx-layout": "^20.0.0",
    "@ngx-translate/core": "^15.0.0",
    "@popperjs/core": "^2.11.8",
    "@types/jquery": "^3.3.37",
    "angular-oauth2-oidc": "^20.0.2",
    "bootstrap": "^5.2.3",
    "jquery": "^3.7.1",
    "jwt-decode": "^4.0.0",
    "launchdarkly-js-client-sdk": "^3.2.0",
    "npm-font-open-sans": "^1.1.0",
    "object-mapper": "^6.2.0",
    "popper.js": "^1.16.1",
    "rxjs": "^6.6.3",
    "tslib": "^2.3.0",
    "whatwg-fetch": "^3.5.0",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^20.3.20",
    "@angular/cli": "^20.3.20",
    "@angular/compiler-cli": "20.3.18",
    "@angular/language-service": "20.3.18",
    "@angularclass/hmr": "3.0.0",
    "@biesbjerg/ngx-translate-extract": "7.0.4",
    "@types/google.maps": "^3.58.1",
    "@types/jasmine": "3.7.7",
    "@types/jasminewd2": "2.0.9",
    "@types/node": "14.17.3",
    "ajv": "^7.2.4",
    "codelyzer": "6.0.2",
    "cross-env": "7.0.3",
    "htmlhint": "^1.1.4",
    "https-proxy-agent": "5.0.0",
    "husky": "4.3.8",
    "jasmine-core": "3.7.1",
    "jasmine-spec-reporter": "6.0.0",
    "karma": "6.4.2",
    "karma-chrome-launcher": "3.1.0",
    "karma-coverage-istanbul-reporter": "3.0.3",
    "karma-jasmine": "4.0.1",
    "karma-jasmine-html-reporter": "1.6.0",
    "karma-junit-reporter": "2.0.1",
    "prettier": "2.3.1",
    "pretty-quick": "3.1.0",
    "stylelint": "13.9.0",
    "stylelint-config-prettier": "8.0.2",
    "stylelint-config-recommended-scss": "4.2.0",
    "stylelint-config-standard": "20.0.0",
    "stylelint-scss": "3.18.0",
    "ts-node": "9.1.1",
    "tslint": "6.1.3",
    "tslint-config-prettier": "1.18.0",
    "typescript": "5.8.3"
  },
  "prettier": {
    "singleQuote": true,
    "overrides": [
      {
        "files": "*.scss",
        "options": {
          "singleQuote": false
        }
      }
    ]
  },
  "husky": {
    "hooks": {
      "pre-commit": "pretty-quick --staged"
    }
  }
}
